
import VideoFeed from 'components/VideoFeed';
import LoginModal from 'features/user/userModals/LoginModal';
import { useAuth } from 'helpers/authContext';
import useModal from 'helpers/useModal';
import React, { useEffect, useState } from 'react';
import { SEO } from 'components/SEO';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Label, Row } from 'reactstrap';
import { get_feed_page, get_post, get_user_preferences, set_user_preferences } from 'services/db-service';
import { getContent } from 'services/posts-service';

export const ScrollPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { author, permlink } = useParams();
    const [preferences, setPreferences] = useState({ preferences: "", lan: "" });
    const [postQueue, setPostQueue] = useState([]);
    const [localReplies, setLocalReplies] = useState([]);
    const [feedError, setFeedError] = useState('');
    const [retry, setRetry] = useState(0);
    const [nextCursor, setNextCursor] = useState<number | null>(null);
    const generation = React.useRef(0);
    const [guest, setGuest] = useState(false);
    const [loading, isLoading] = useState(true);
    const [step, setStep] = useState(1);
    const [transitioning, setTransitioning] = useState(false);
    const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
    const [lan, setLan] = useState<string>("");
    const { isOpenLoginModal, toggleLoginModal } = useModal();

    useEffect(() => {
        setStep(1);
        setSelectedTopics([]);
    }, [user]);

    useEffect(() => {
        if (author && permlink && !user && !guest) {
            setGuest(true);
        }
    }, [author, permlink, user, guest]);
    useEffect(() => {
        const getPreferences = async () => {
            let data = await get_user_preferences(user).catch(() => []);
            setPreferences(data[0] || { preferences: "", lan: "" });
            // setLan()
            console.log("Preferences:", data[0]);
        };
        getPreferences();
    }, [user]);

    useEffect(() => {
        const current = ++generation.current;
        let alive = true;
        const loadFeed = async () => {
            isLoading(true);
            setFeedError('');
            setNextCursor(null);
            try {
                let mainPost = null;
                if (author && permlink) {
                    try {
                        const post = await get_post(author, permlink);
                        mainPost = post ? [post[0]] : [];
                        if (!post || post?.postType == "BLOG") {
                            navigate(`/p/${author}/${permlink}`, { replace: true });
                        }
                    } catch (error) {
                        console.log("Backend get_post failed, trying Steem blockchain fallback...", error);
                        // Fallback: fetch directly from Steem blockchain (same as /p/ route)
                        try {
                            const steemPost = await getContent(author, permlink);
                            if (steemPost && steemPost.author) {
                                mainPost = [steemPost];
                                console.log("Steem fallback succeeded for", author, permlink);
                            }
                        } catch (fallbackError) {
                            console.log("Steem fallback also failed", fallbackError);
                        }
                    }
                }

                const page = await get_feed_page(user || null);
                if (!alive || current !== generation.current) return;
                const feed = page.posts;
                setNextCursor(page.nextCursor);
                const combined = (mainPost && mainPost[0])
                    ? [mainPost[0], ...feed.filter(p => p.permlink !== mainPost[0].permlink || p.author !== mainPost[0].author)]
                    : feed;

                console.log("Final feed:", combined);
                setPostQueue(combined);
            } catch (err) {
                if (alive && current === generation.current) setFeedError('Videos could not be loaded. Please try again.');
            } finally {
                if (alive && current === generation.current) isLoading(false);
            }
        };

        if ((user && preferences?.preferences.length > 0) || guest) {
            loadFeed();
        }
        return () => { alive = false; };
    }, [user, preferences, guest, author, permlink, retry]);

    const loadMore = React.useCallback(async () => {
        if (nextCursor === null) return [];
        const current = generation.current;
        const page = await get_feed_page(user || null, nextCursor);
        if (current !== generation.current) return [];
        setNextCursor(page.nextCursor);
        return page.posts;
    }, [user, nextCursor]);
    const goToStep = (nextStep: number) => {
        setTransitioning(true);
        setTimeout(() => {
            setStep(nextStep);
            setTransitioning(false);
        }, 500); // duración del fade-out
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const params = {
            username: user,
            preferences: selectedTopics.join(',') || "",
            lan: lan || "en",
        };
        console.log(params);

        try {
            const res = await set_user_preferences(params);
            console.log('Preferences saved:', res);
            if (!res.error) {
                goToStep(4);
                setTimeout(() => {
                    setPreferences(params);
                }, 5000);
            }
        } catch (err) {
            console.error('Error saving preferences:', err);
        }
    };
    // const handleSkip = async () => {
    //     const params = {
    //         username: user,
    //         preferences: '', 
    //         lan: '',
    //     };

    //     try {
    //         const res = await set_user_preferences(params);
    //         console.log('Preferences skipped:', res);
    //         if (!res.error) {
    //             goToStep(4);
    //             setTimeout(() => {
    //                 setPreferences(params);
    //             }, 5000);
    //         }
    //     } catch (err) {
    //         console.error('Error skipping preferences:', err);
    //     }
    // };

    const handleCheckboxChange = (topic: string, checked: boolean) => {
        setSelectedTopics((prev) =>
            checked ? [...prev, topic] : prev.filter((t) => t !== topic)
        );
    };
    useEffect(() => {
        let topics = preferences?.preferences.split(",") || [];
        topics.forEach(topic => {
            handleCheckboxChange(topic, true);
        });
    }, [preferences]);
    return (
        <>
            <SEO 
                title="Discover"
                description="Discover the newest content on Speak on Steem in a infinite scroll format."
                type="website"
            />

            <div className="scroll-content">

                {(!user && !guest) && (
                    <div className="screen speem-welcome-screen">
                        <div className="speem-welcome-content">
                            <h1 className="speem-welcome-heading">Welcome to Speak on Steem!</h1>
                            <p className="speem-welcome-copy">Log in to set your experience or watch videos as guest.</p>
                            <div className="speem-welcome-actions">
                                <button type="button" className="speem-welcome-cta speem-welcome-primary" onClick={() => { setGuest(true) }}>
                                    Take a sneak peek
                                </button>
                                <button type="button" className="speem-welcome-cta speem-welcome-login" onClick={toggleLoginModal}>
                                    Log in
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {(user && (preferences?.preferences.length > 0 && preferences?.lan != "") || guest) && (
                    <>
                        {(postQueue.length == 0 && !loading && !feedError) && (
                            <>
                                <h2>You are up to date.</h2>
                                <p>Come later to see more videos.</p>
                            </>
                        )}
                        {feedError && <div className="screen" role="alert"><p>{feedError}</p><button type="button" className="speem-welcome-cta speem-welcome-primary" onClick={() => setRetry(value => value + 1)}>Try again</button></div>}
                        {(postQueue.length == 0 && loading) && (
                            <div className="screen">
                                <span className="spinner m-0"></span>
                            </div>
                        )}
                        {postQueue.length > 0 && (
                            <>
                                <VideoFeed
                                    posts={postQueue}
                                    toggleLoginModal={toggleLoginModal}
                                    localReplies={localReplies}
                                    setLocalReplies={setLocalReplies}
                                    fetchMore={loadMore}
                                    hasMore={nextCursor !== null}
                                />
                            </>
                        )}
                    </>
                )}

                {(user && (!preferences || preferences?.preferences.length === 0 || preferences?.lan == "")) && (
                    <>
                        {step == 1 && (
                            <div className={`screen ${transitioning ? 'fade-out' : 'fade-in'}`}>
                                <h1 className="typing">Welcome to Speak on Steem!</h1>
                                <p className="typing delay-1">Let's set your experience.</p>

                                <button type="button" className="btn btn-fade btn-preferences-start" onClick={() => { goToStep(2) }}>
                                    Get started <i className="fas fa-chevron-right" />
                                </button>
                            </div>
                        )}
                        {step == 2 && (
                            <div className={`screen ${transitioning ? 'fade-out' : 'fade-in'}`}>
                                <form className="container-fluid" onSubmit={handleSubmit}>
                                    <Row>
                                        <Col sm={{ offset: 2, size: 8 }} md={{ offset: 2, size: 8 }} lg={{ offset: 3, size: 6 }}>
                                            <h2 className="typing">Which topics do you like?</h2>
                                        </Col>
                                    </Row>
                                    <div className="form-fade">
                                        <Row>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-flask" /> <span>Science</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('science', e.target.checked)}
                                                        checked={selectedTopics.includes('science') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-pencil" /> <span>Art</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('art', e.target.checked)}
                                                        checked={selectedTopics.includes('art') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-heart" /> <span>Life</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('life', e.target.checked)}
                                                        checked={selectedTopics.includes('life') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-computer" /> <span>Technology</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('technology', e.target.checked)}
                                                        checked={selectedTopics.includes('technology') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-cookie" /> <span>Cooking</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('cooking', e.target.checked)}
                                                        checked={selectedTopics.includes('cooking') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-face-laugh" /> <span>Entertainment</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('entertainment', e.target.checked)}
                                                        checked={selectedTopics.includes('entertainment') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-gamepad" /> <span>Games</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('games', e.target.checked)}
                                                        checked={selectedTopics.includes('games') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='topic'>
                                                    <i className="fas fa-plane" /> <span>Travel</span>{" "}
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckboxChange('travel', e.target.checked)}
                                                        checked={selectedTopics.includes('travel') ? true : false}
                                                    />
                                                </Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12" className='scroll-page-buttons'>
                                                <button className="btn btn-underline" type="button" onClick={() => { goToStep(3) }}>Skip</button>
                                                <button className="btn btn-white" type="button" onClick={() => { goToStep(3) }}>Next <i className="fas fa-chevron-right" /></button>
                                            </Col>
                                        </Row>
                                    </div>
                                </form>
                            </div>
                        )}
                        {step == 3 && (
                            <div className={`screen ${transitioning ? 'fade-out' : 'fade-in'}`}>
                                <form className="container-fluid" onSubmit={handleSubmit}>
                                    <Row>
                                        <Col sm={{ offset: 2, size: 8 }} md={{ offset: 2, size: 8 }} lg={{ offset: 3, size: 6 }}>
                                            <h2 className="typing">Which language do you prefer?</h2>
                                        </Col>
                                    </Row>
                                    <div className="form-fade">
                                        <Row>
                                            <Col md="6">
                                                <Label className='lan-option'>
                                                    🇪🇸 <span>Spanish</span>{" "}
                                                    <input
                                                        type="radio"
                                                        name='language'
                                                        onChange={() => setLan('es')}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='lan-option'>
                                                    🇺🇸 <span>English</span>{" "}
                                                    <input
                                                        type="radio"
                                                        name='language'
                                                        onChange={() => setLan('en')}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='lan-option'>
                                                    🇧🇩 <span>Bengali</span>{" "}
                                                    <input
                                                        type="radio"
                                                        name='language'
                                                        onChange={() => setLan('bn')}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='lan-option'>
                                                    🇨🇳 <span>Chinese</span>{" "}
                                                    <input
                                                        type="radio"
                                                        name='language'
                                                        onChange={() => setLan('zn')}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col md="6">
                                                <Label className='lan-option'>
                                                    🇮🇹 <span>Italian</span>{" "}
                                                    <input
                                                        type="radio"
                                                        name='language'
                                                        onChange={() => setLan('it')}
                                                    />
                                                </Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12" className='scroll-page-buttons'>
                                                {/* <button className="btn btn-underline" type="button" onClick={handleSkip}>Skip</button> */}
                                                <button className="btn btn-white" type="submit" disabled={lan ? false : true}>Next <i className="fas fa-chevron-right" /></button>
                                            </Col>
                                        </Row>
                                    </div>
                                </form>
                            </div>
                        )}
                        {step === 4 && (
                            <div className={`screen ${transitioning ? 'fade-out' : 'fade-in'}`}>
                                <h2>🎉 Preferences saved!</h2>
                                <p>We'll personalize your experience accordingly.</p>
                                <div className="spinner dark"></div>
                            </div>
                        )}
                    </>
                )}
            </div>

            <LoginModal
                isShowing={isOpenLoginModal}
                hide={toggleLoginModal}
            />
        </>
    );
};
